<div class="forgot-password-component">
  <h3 *ngIf="finished">Successfully unsubscribed</h3>
</div>
